import { CIcon } from '~/icons/types'
export const ciThreeDots: CIcon = {
  width: 17,
  height: 4,
  paths: [
    {
      d:
        'M3.167 2a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0ZM9.834 2a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0ZM16.5 2a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z'
    }
  ],
  name: 'three-dots',
  type: 'regular'
}
